module.exports = __webpack_public_path__ + "33ddaff41c6539bfdc8f5a67abb60db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_4.png
// module id = 127
// module chunks = 1